import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { RedirectTypeBadge } from "@/components/base/Badges";
import { useAppData } from "@/hooks/useDomains";

export default function GoPage() {
  const { id } = useParams();
  const { domains, settings } = useAppData();
  const item = domains.find((domain) => domain.id === id);
  const [left, setLeft] = useState(false);
  const destination = item?.status === "active" ? item.targetUrl : settings.fallbackUrl;
  const mode = !item ? "missing" : item.status !== "active" ? "paused" : item.redirectType;

  useEffect(() => {
    if (mode === "mask") return undefined;
    const timer = window.setTimeout(() => {
      setLeft(true);
      window.location.replace(destination);
    }, 1600);
    return () => window.clearTimeout(timer);
  }, [mode, destination]);

  if (item?.status === "active" && item.redirectType === "mask") {
    return (
      <div className="flex h-screen w-full flex-col bg-background-50">
        <div className="flex items-center justify-between gap-3 border-b border-background-200 px-4 py-2.5">
          <div className="flex min-w-0 items-center gap-2">
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-route-line text-sm" />
            </span>
            <p className="truncate text-sm text-foreground-700">
              <span className="font-medium text-foreground-950">{item.domain}</span>
              <span className="text-foreground-400"> · 隐藏跳转</span>
            </p>
          </div>
          <a
            href={item.targetUrl}
            className="shrink-0 text-xs font-medium text-primary-700 hover:text-primary-800"
          >
            直接打开
          </a>
        </div>
        <iframe title={item.domain} src={item.targetUrl} className="h-full w-full flex-1 border-0 bg-background-50" />
      </div>
    );
  }

  const heading = !item ? "没有找到这个跳转" : item.status === "paused" ? "这条跳转已暂停" : "正在前往目标页面";
  const detail = !item
    ? "链接无效或已被删除，即将打开兜底地址。"
    : item.status === "paused"
      ? `${item.domain} 当前未在分发流量，即将打开兜底地址。`
      : `${item.domain} 将打开目标页面。`;
  const href = item?.status === "active" ? item.targetUrl : settings.fallbackUrl;

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background-50 px-6">
      <div className="w-full max-w-md rounded-lg border border-background-200 bg-background-50 p-8 text-center animate-fade-up">
        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500 text-background-50">
          <i className={left ? "ri-loader-4-line animate-spin text-2xl" : "ri-route-line text-2xl"} />
        </span>
        <h1 className="mt-5 font-heading text-xl font-semibold text-foreground-950">{heading}</h1>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600">{detail}</p>
        {item && item.status === "active" ? (
          <div className="mt-4 flex justify-center">
            <RedirectTypeBadge type={item.redirectType} />
          </div>
        ) : null}
        <a
          href={href}
          className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-800"
        >
          {left ? "正在打开…" : "如果没有自动跳转，点这里"}
          <i className="ri-arrow-right-line" />
        </a>
      </div>
    </div>
  );
}
